import './styles.scss';

import React from 'react';
import { Icon } from 'semantic-ui-react';
import Select, { components } from 'react-select';
import { connect } from 'react-redux';
import { FormattedMessage, injectIntl } from 'react-intl';
import _ from 'lodash';

import 'react-datepicker/dist/react-datepicker.css';
import { selectLoggedIn } from 'app/redux/global/selectors';
import { ANIMAL_SEARCH_STYLE } from 'app/components/AnimalSearch/AnimalSearchSelectStyle';

const CUSTOM_STYLES = _.merge({}, ANIMAL_SEARCH_STYLE, {});
// {
//   container: (provided) => ({
//     ...provided,
//     lineHeight: '1',
//     height: '100%',
//   }),
//   dropdownIndicator: (provided) => ({
//     ...provided,
//     display: 'none',
//   }),
//   indicatorSeparator: (provided) => ({
//     ...provided,
//     display: 'none',
//   }),
//   clearIndicator: (provided) => ({
//     ...provided,
//     minHeight: '10px',
//     padding: '0',
//   }),
//   control: (provided) => ({
//     ...provided,
//     backgroundColor: '#5e5e5e',
//     color: 'white',
//     borderColor: '#5e5e5e',
//     fontSize: 12,
//     height: '100%',
//     minHeight: 30,
//     padding: '0',
//   }),
//   menu: (provided) => ({
//     ...provided,
//     zIndex: '4',
//     width: 'fit-content',
//     backgroundColor: '#444645',
//   }),
//   option: (provided, state) => ({
//     ...provided,

//     fontSize: 13,
//     backgroundColor: state.isSelected ? 'rgba(255, 255, 255, 0.3)' : 'transparent',
//     ':hover': {
//       backgroundColor: 'rgba(255, 255, 255, 0.2)',
//     },
//   }),
//   placeholder: () => ({
//     color: 'white',
//     flexGrow: '1',
//     textAlign: 'center',
//   }),
//   multiValue: (provided) => ({
//     ...provided,
//     backgroundColor: 'transparent',
//   }),
//   multiValueLabel: (provided) => ({
//     ...provided,
//     color: 'white',
//     lineHeight: 1,
//     textAlign: 'center',
//     backgroundColor: '#7e7979',
//   }),
//   multiValueRemove: (styles) => ({
//     ...styles,
//     width: 15,
//     backgroundColor: '#7e7979',
//     borderColor: '#7e7979',
//   }),
//   input: (provided) => ({
//     ...provided,
//     height: '0',
//     width: '0',
//   }),
// };

function ValueContainer({ children, ...props }) {
  return (
    components.ValueContainer && (
      <components.ValueContainer {...props}>
        {!!children && <Icon name="filter" style={{ lineHeight: 1 }} />}
        <div
          className="flex"
          style={{
            position: 'relative',
            width: '100%',
            alignItems: 'center',
            justifyContent: 'flex-start',
          }}
        >
          {children}
        </div>
      </components.ValueContainer>
    )
  );
}

class RegionsFilter extends React.Component {
  // eslint-disable-next-line react/destructuring-assignment
  formatMessage = (...args) => this.props.intl.formatMessage(...args);

  render() {
    const regionsOptions = [
      {
        label: this.formatMessage({ id: 'monitoring.regions.thorax' }),
        value: 'thorax',
      },
      {
        label: this.formatMessage({ id: 'monitoring.regions.abdomen' }),
        value: 'abdomen',
      },
      {
        label: this.formatMessage({ id: 'monitoring.regions.pelvis' }),
        value: 'pelvis',
      },
      {
        label: this.formatMessage({ id: 'monitoring.regions.autre' }),
        value: 'autre',
      },
    ];
    return (
      <Select
        isMulti
        className="regions-filter"
        styles={CUSTOM_STYLES}
        placeholder={this.formatMessage({ id: 'monitoring.regions' })}
        options={regionsOptions}
        components={{ ValueContainer }}
        onChange={this.props.setRegions}
        noOptionsMessage={() => null}
        isSearchable={false}
        isDisabled={this.props.isDisabled}
      />
    );
  }
}

function mapStateToProps(state) {
  return {
    isLoggedIn: selectLoggedIn(state),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(RegionsFilter));
